import React, { Component } from 'react';
import './Navigation.css';
import base64 from 'base-64';


class Navigation extends Component {

  constructor(props){
    super(props);
     this.state = {
      redirect:false
     }
  }

  componentWillMount(){
    if(!sessionStorage.getItem("pk_token")){
      this.props.history.push("/");
     }
     else{
       this.setState({redirect:true});
     }
  }


  populateButtons = () => {
    let userInfo = JSON.parse(JSON.parse(base64.decode(sessionStorage.getItem("pk_token").split(".")[1])).data.sites); 
    let buttons = [];
    Object.keys(userInfo).forEach(site => {
      buttons.push(<a className="links" key={site} href={'https://'+site}>{site}</a>);
    }) ;
   return buttons;
  }

  render() {
    return (
      <div className="Navigation">
      <div id="linkButtons">
          {this.state.redirect && this.populateButtons()}
          </div>
      </div>
    );
  
  }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Navigation.js